module.exports = __webpack_public_path__ + "static/media/sherritt-header-0003.aff3a247.jpg";